export default __webpack_public_path__ + "static/media/category.abb42c18.svg";